export default {
  title: "Catalogue search",
  placeholder: "Author, title, ISBN, prize…",
  submit: "Search",
  results: "Results",
  noQueryHint: "Enter a query or pick a facet.",
  empty: "No results. Try a different query or clear filters.",
  sort: "Sort",
  sortRelevance: "Relevance",
  sortTitle: "Title",
  sortYearDesc: "Newest first",
  sortYearAsc: "Oldest first",
  facets: "Filters",
  facetType: "Type",
  facetYear: "Year",
  facetLanguage: "Language",
  facetRole: "Role",
  facetSubject: "Subject",
  facetPrize: "Prize",
  facetPublisher: "Publisher",
  facetSeries: "Series",
  yearFrom: "Year from",
  yearTo: "Year to",
  clearFacets: "Clear filters",
  saveQuery: "Save query",
  saveQueryTitle: "Saved query title",
  saved: "Query saved to your account",
  took: "in {{ms}} ms",
  relatedPeople: "People",
  relatedPrizes: "Prizes",
  relatedConcepts: "Subjects",
  relatedAgents: "Organizations",
  clusterEditions: "Editions",
  clusterOrphan: "Work not linked",
  moreEditions: "{{count}} more",
}
